import React from 'react';
import MissionDetail from './MissionDetail';
import missionsData from '../data/missions.json';

function MissionPovertyAlleviation() {
  return <MissionDetail mission={missionsData.povertyAlleviation} />;
}

export default MissionPovertyAlleviation;
